import { render, staticRenderFns } from "./ServiceList.vue?vue&type=template&id=bf9e3dae&scoped=true&"
import script from "./ServiceList.vue?vue&type=script&lang=js&"
export * from "./ServiceList.vue?vue&type=script&lang=js&"
import style0 from "./ServiceList.vue?vue&type=style&index=0&id=bf9e3dae&lang=scss&scoped=true&"
import style1 from "./ServiceList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9e3dae",
  null
  
)

export default component.exports